import { accountHttp } from './http';
import { BasketApiErrorModel, isApiError } from 'models/Errors';
import { errorToBasketErrorModel } from 'helpers';

export class AccountRepository {
    public async getCustomerUserId(username: string, token: string): Promise<string> {
        try {
            const response = await accountHttp.get<{ userId: string }>('/api/users', {
                params: {
                    username: username
                },
                headers: { Authorization: token }
            });

            return response.data.userId;
        } catch (error) {
            const errorSource = 'account.repository:getCustomerUserId';
            if (isApiError(error)) {
                throw new BasketApiErrorModel(error, errorSource);
            } else {
                throw errorToBasketErrorModel(error, errorSource);
            }
        }
    }
}

export const account = new AccountRepository();